import { Component, Vue, Prop, Watch } from 'vue-property-decorator';


import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';

@Component({
    name: 'topics-list-panel',
    components: {

    },
  })

export default class TopicsListPanel extends Vue {

    @Prop()
        public domain!: Domain;

    @Prop()
        private userId!: string;

    @Prop()
        private month!: string;

    @Prop()
        private year!: string;

        private isLoading: boolean = false;
    get domainTopics() {
        return this.domain.topics || [];
    }

    public onSelectTopic(topic: Topic) {
        this.$emit('onSelectTopic', topic);
    }
}
